import React from "react";
import ReactTooltip from 'react-tooltip'
import moment from 'moment'
import 'react-datepicker/dist/react-datepicker.css'
import 'react-dates/lib/css/_datepicker.css'

import { Row, Column } from 'components/Layout'
import { alertIcon_tri as alertIcon } from 'img/icons'
import style from './_eventlog.module.scss'


export default class LogItem extends React.Component {

	dayBox = timestamp => <div className={style.daybox}>{moment(timestamp).format("dddd DD MMMM YYYY")}</div>;

	alertSignal = message => <div className={style.alert}>
		<div data-tip={message}>
			<img src={alertIcon} alt="alert" style={{width:"20px", height:"20px"}}/>
		</div>
		<ReactTooltip className={style.tooltip} effect='solid'/>
	</div>;

	infoBox = (name, value, mu) => <Row className={`${style.infobox} ${style.underlined}`}>
		{name && <div className={style.title}>{`${name}`}</div>}
		<div>{value}{mu && mu}</div>
	</Row>;

	render() {

		let {item, pos, showday, isLast} = this.props;
		let icon = this.props.getIcon(item.messageType);
		let day;

		if(showday) {
			day = <Column>
				{this.dayBox(item.timestamp)}
				<div className={style.dayline}/>
			</Column>;
		}

		return <Column>
			{day}
			<Row className={style.detectionRow} onClick={this.props.onClick}>
				<Column className={`icon-${pos} ${style.icon}`}>
					<img src={icon} alt={item.messageType} style={{cursor:"pointer"}}/>
					{!isLast && <div className={style.line}/>}
				</Column>
				<Column>
					{this.props.children}
				</Column>
			</Row>
		</Column>
	}
}
